import { useState } from "react"; // useEffect
import Plot from "react-plotly.js";
import { DataGrid } from "@mui/x-data-grid";
import Paper from "@mui/material/Paper";
import {
  genephenotypeassociationsColumns,
  genepathwayassociationsColumns,
  genegeneinteractionsColumns,
} from "../../utils/tableheaders";
import { TableCellsIcon } from "@heroicons/react/24/outline";
import quickTargetData from "../../data/data.json";

const KnownDatabaseLink = (props: any) => {
  // const [activetab, setActivetab] = useState(0);
  // const tabNames = [
  //   "Known Database Link",
  //   "Single Cell Perturbation Prediction",
  //   "Mechanisms identified based on Literature",
  // ];
  const [radioval, setRadioval] = useState("genephenotypeassociations");
  const paginationModel = { page: 0, pageSize: 5 };

  return (
    <div className="space-y-6">
      <div className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-2xl p-8 border border-blue-200">
        <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
          <TableCellsIcon className="h-8 w-8 mr-3 text-blue-600" />
          Known Database Link
        </h3>
        {props.selectedgene ? (
          <div className="space-y-4">
            <div className="bg-white rounded-xl p-6 shadow-sm">
              <h4 className="text-lg font-bold text-gray-900 mb-2">
                Gene Symbol: {props.selectedgene}
              </h4>
              {/* <div className="py-2">
                <ul className="flex flex-wrap text-sm font-medium text-center text-gray-500 border-b border-gray-400 dark:border-gray-700 dark:text-gray-400">
                  {tabNames.map((itm, index) => {
                    return (
                      <li className="me-2">
                        <span
                          aria-current="page"
                          onClick={() => setActivetab(index)}
                          className={`inline-block p-4 rounded-t-lg cursor-pointer ${
                            activetab === index
                              ? "bg-gray-100 active dark:bg-gray-800 dark:text-blue-500 text-blue-600"
                              : "hover:text-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800 dark:hover:text-gray-300"
                          }`}
                        >
                          {itm}
                        </span>
                      </li>
                    );
                  })}
                </ul>
              </div> */}
              <div className="py-2">
                {quickTargetData.knowndatabaselink.content}
              </div>
              <div className="py-2 h-[480px] mb-10">
                <Plot
                  data={[
                    {
                      x: ["HFpEF", "HF", "HFrEF", "DCM"], // X axis
                      y: [0, 1, 2, 3], // y axis
                      type: "scatter",
                      mode: "lines+markers",
                      marker: { color: "red" },
                    },
                    {
                      type: "bar",
                      x: ["HFpEF", "HF", "HFrEF", "DCM"],
                      y: [2.5, 2.75, 2.75, 3],
                    },
                  ]}
                  config={{
                    responsive: true,
                    displayModeBar: true,
                    displaylogo: false,
                    modeBarButtons: [["toImage"]],
                    modeBarButtonsToRemove: [
                      "lasso2d",
                      "select2d",
                      "hoverClosestCartesian",
                      "hoverCompareCartesian",
                    ],
                    toImageButtonOptions: {
                      format: "png",
                      filename: "bubble_plot",
                    },
                  }}
                  layout={{
                    xaxis: {
                      // title: { text: "Disease" },
                      zeroline: true,
                      zerolinewidth: 2,
                      zerolinecolor: "black",
                    },
                    yaxis: {
                      title: { text: "z-score" },
                      zeroline: false,
                    },
                    hovermode: "closest",
                    margin: { l: 40, r: 20, t: 20, b: 40 },
                    autosize: true,
                    // width: 0.1,
                    // height: 240,
                    title: { text: "Disease association score" },
                  }}
                />
              </div>
              <h4 className="text-md font-bold text-gray-900 mb-2">
                {quickTargetData.associationtypeText}
              </h4>
              <div className="flex flex-row py-2 mb-4 gap-4">
                <div className="items-center">
                  <input
                    type="radio"
                    id="default-radio-1"
                    name="default-radio"
                    value="genephenotypeassociations"
                    checked={radioval === "genephenotypeassociations"}
                    onClick={() => setRadioval("genephenotypeassociations")}
                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  />
                  <label
                    htmlFor="default-radio-1"
                    className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                  >
                    Gene-Phenotype Associations
                  </label>
                </div>
                <div className="items-center">
                  <input
                    type="radio"
                    name="default-radio"
                    id="default-radio-2"
                    value="genepathwayassociations"
                    checked={radioval === "genepathwayassociations"}
                    onClick={() => setRadioval("genepathwayassociations")}
                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  />
                  <label
                    htmlFor="default-radio-2"
                    className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                  >
                    Gene-Pathway Associations
                  </label>
                </div>
                <div className="items-center">
                  <input
                    type="radio"
                    id="default-radio-3"
                    name="default-radio"
                    value="genegeneinteractions"
                    checked={radioval === "genegeneinteractions"}
                    onClick={() => setRadioval("genegeneinteractions")}
                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  />
                  <label
                    htmlFor="default-radio-3"
                    className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                  >
                    Gene-Gene Interactions
                  </label>
                </div>
              </div>
              <div className="py-2">
                {radioval === "genephenotypeassociations" ? (
                  <p>
                    Gene-phenotype associations sorted by ML-based link
                    prediction score between the chosen gene and phenotypes.
                    Heart disease-related phenotypes are highlighted in teal.
                    The 'in_KG' flag indicates whether this association is
                    known.
                  </p>
                ) : radioval === "genepathwayassociations" ? (
                  <p>
                    Gene-pathway associations sorted by ML-based link prediction
                    score. The 'in_KG' flag indicates whether this association
                    is known.
                  </p>
                ) : radioval === "genegeneinteractions" ? (
                  <p>
                    Gene-gene interactions sorted by ML-based link prediction
                    score. Top Heart disease-associated genes are highlighted in
                    teal.
                  </p>
                ) : (
                  <p>
                    Gene-phenotype associations sorted by ML-based link
                    prediction score between the chosen gene and phenotypes.
                    Heart disease-related phenotypes are highlighted in teal.
                    The 'in_KG' flag indicates whether this association is
                    known.
                  </p>
                )}
              </div>
              <div className="py-2">
                <Paper sx={{ width: "100%", minHeight: "380px" }}>
                  {radioval === "genephenotypeassociations" && (
                    <DataGrid
                      getRowId={(row) => row.id}
                      rows={
                        quickTargetData.associationtype
                          .genephenotypeassociations
                      }
                      columns={genephenotypeassociationsColumns}
                      initialState={{ pagination: { paginationModel } }}
                      pageSizeOptions={[5, 10]}
                      sx={{ border: 0 }}
                    />
                  )}
                  {radioval === "genepathwayassociations" && (
                    <DataGrid
                      getRowId={(row) => row.id}
                      rows={
                        quickTargetData.associationtype.genepathwayassociations
                      }
                      columns={genepathwayassociationsColumns}
                      initialState={{ pagination: { paginationModel } }}
                      pageSizeOptions={[5, 10]}
                      sx={{ border: 0 }}
                    />
                  )}
                  {radioval === "genegeneinteractions" && (
                    <DataGrid
                      getRowId={(row) => row.id}
                      rows={
                        quickTargetData.associationtype.genegeneinteractions
                      }
                      columns={genegeneinteractionsColumns}
                      initialState={{ pagination: { paginationModel } }}
                      pageSizeOptions={[5, 10]}
                      sx={{ border: 0 }}
                    />
                  )}
                </Paper>
              </div>
            </div>
          </div>
        ) : (
          <div className="text-center py-12 text-gray-500">
            <div className="text-6xl mb-4">🧬</div>
            <p>Enter a gene symbol to view detailed information</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default KnownDatabaseLink;
